import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { StaffCombobox } from "@/components/StaffCombobox";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";

export function BackupPicker({ entry, onSaved, label = "Add backup", testid }) {
  const [open, setOpen] = useState(false);
  const save = async (name, email) => {
    if (!email) return;
    try {
      await api.patch(`/ooo/${entry.id}`, { backup_email: email, backup_name: name });
      toast.success(`${name} is now the backup for ${entry.user_name}`);
      setOpen(false); onSaved?.();
    } catch (e) { console.error("backup", e); toast.error(e?.response?.data?.detail || "Could not set backup"); }
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button size="sm" variant="outline" className="h-7 text-xs" data-testid={testid || `ooo-set-backup-${entry.id}`}><UserPlus className="h-3 w-3 mr-1" /> {label}</Button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-3" align="end">
        <div className="text-xs font-semibold mb-2">Backup for {entry.user_name}</div>
        <StaffCombobox testid={`${testid || `ooo-set-backup-${entry.id}`}-pick`} value={entry.backup_name || ""} placeholder="Who covers?" onChange={save} />
      </PopoverContent>
    </Popover>
  );
}
